import { useEffect, useState, useMemo } from "react"
import { FormProvider, useForm } from "react-hook-form"

// Helpers
import {
  getVariationAttributes,
  getDefaultAttributes,
  getAttributes,
  getActiveSelectControlOptions,
  getVariationMatchingSelectedAttributes
} from "@/lib/helpers/woocommerce"

// Hooks
import { useMeta } from "@/lib/contexts/appContext"

// Components
import AddToCart from "@/components/woocommerce/AddToCart"
import RadioButton from "@/components/common/form/radioButton"

const AddToCartVariation = ({
  product,
  wrapperClasses,
  customPrice,
  disabledButton = false,
  callback = false,
  campaignCode = false,
  setCurrentVariationId = () => {}
}) => {
  const {
    woocommerce: { shop_enabled }
  } = useMeta()

  const attributes = getAttributes(product.attributes)
  const variationAttributes = getVariationAttributes(product.variations)

  const currentAttributes = attributes
  const currentVariationAttributes = variationAttributes
  const [variationId, setVariationId] = useState(0)

  const methods = useForm({
    defaultValues: {
      ...(product.default_attributes
        ? product.default_attributes
        : getDefaultAttributes(currentAttributes))
    }
  })

  const { watch } = methods

  const selectedAttributes = watch()

  // Get options for each attribute picker.
  const filteredAttributeOptions = useMemo(() => {
    return getActiveSelectControlOptions(
      currentAttributes,
      currentVariationAttributes,
      []
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAttributes, currentAttributes, currentVariationAttributes])

  // Select variations when selections are change.
  useEffect(() => {
    const hasSelectedAllAttributes =
      Object.values(selectedAttributes).filter((selected) => selected !== "")
        .length === Object.keys(currentAttributes).length

    if (hasSelectedAllAttributes) {
      setVariationId(
        getVariationMatchingSelectedAttributes(
          currentAttributes,
          currentVariationAttributes,
          selectedAttributes
        )
      )

      setCurrentVariationId(
        getVariationMatchingSelectedAttributes(
          currentAttributes,
          currentVariationAttributes,
          selectedAttributes
        )
      )
    } else if (variationId > 0) {
      // Unset variation when form is incomplete.
      setVariationId(0)
      setCurrentVariationId(0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedAttributes,
    variationId,
    currentAttributes,
    currentVariationAttributes
  ])

  if (!shop_enabled) {
    return null
  }

  return (
    <FormProvider {...methods}>
      <form className="mt-4">
        <div className={wrapperClasses}>
          {Object.keys(currentAttributes).map((attributeName) => {
            if (customPrice && attributeName === "Priskategori") {
              return null
            }

            return filteredAttributeOptions[attributeName].map((item) => {
              return (
                <RadioButton
                  key={`${product.id}-${item.value}`}
                  id={`variation-${product.id}-${item.value}`}
                  name={attributeName}
                  title={item.label}
                  value={item.value}
                  isSmall
                />
              )
            })
          })}
        </div>
      </form>
      <AddToCart
        product={product}
        variation={selectedAttributes}
        customPrice={customPrice}
        disabledButton={disabledButton}
        callback={callback}
        campaignCode={campaignCode}
      />
    </FormProvider>
  )
}

export default AddToCartVariation
